var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        _vm._b(
          {
            ref: "multipleTable",
            staticClass: "mt10",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, height: _vm.tableHeight },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          "el-table",
          _vm.$attrs,
          false
        ),
        [
          _c("el-table-column", {
            attrs: { label: "姓名", "min-width": "100", prop: "name" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "性别", "min-width": "90", prop: "sex" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.getSex(scope.row.sex)))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "学历", prop: "education" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getEducation(scope.row.education))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.notEmployees == "未入职" ? "面试职位" : "职位",
              prop:
                _vm.notEmployees == "未入职"
                  ? "interview_position"
                  : "job.name",
              "min-width": "140",
            },
          }),
          _vm._v(" "),
          _vm.notEmployees !== "未入职"
            ? _c("el-table-column", {
                attrs: {
                  label: "部门",
                  "min-width": "120",
                  prop: "frame.name",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(scope.row.frames, function (item, index) {
                          return _c("div", { key: index }, [
                            _c("span", { staticClass: "icon-h" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.name) +
                                  "\n            "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.is_mastart === 1 &&
                                        scope.row.frames.length > 1,
                                      expression:
                                        "item.is_mastart === 1 && scope.row.frames.length > 1",
                                    },
                                  ],
                                  attrs: { title: "主部门" },
                                },
                                [_vm._v("(主)")]
                              ),
                            ]),
                          ])
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  3976257331
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "手机号码",
              "min-width": "110",
              prop: "phone",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "类型",
              "min-width": "80",
              prop: "is_part",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getIsPart(scope.row.is_part))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "员工状态", prop: "name", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.type == 1,
                            expression: "scope.row.type == 1",
                          },
                        ],
                        staticClass: "table-btn blue",
                      },
                      [_vm._v(_vm._s(_vm.$t("toptable.formal")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.type == 2,
                            expression: "scope.row.type == 2",
                          },
                        ],
                        staticClass: "table-btn yellow",
                      },
                      [_vm._v(_vm._s(_vm.$t("toptable.ontrial")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.type == 3,
                            expression: "scope.row.type == 3",
                          },
                        ],
                        staticClass: "table-btn green",
                      },
                      [_vm._v(_vm._s(_vm.$t("toptable.internship")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.type == 4,
                            expression: "scope.row.type == 4",
                          },
                        ],
                        staticClass: "table-btn yellow",
                      },
                      [_vm._v(_vm._s(_vm.$t("toptable.dimission")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.type == 0,
                            expression: "scope.row.type == 0",
                          },
                        ],
                        staticClass: "table-btn gray",
                      },
                      [_vm._v("未入职")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.addTime,
              prop: _vm.propTime,
              "min-width": "110px",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _vm.notEmployees !== "未入职"
            ? _c("el-table-column", {
                attrs: { label: "账号状态", "min-width": "110", prop: "name" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.uid == ""
                            ? _c("div", { staticClass: "table-txt" }, [
                                _c("i", { staticClass: "bg-danger" }),
                                _vm._v("\n          未激活\n        "),
                              ])
                            : scope.row.status == 0
                            ? _c("div", { staticClass: "table-txt" }, [
                                _c("i", { staticClass: "bg-danger" }),
                                _vm._v("\n          未激活\n        "),
                              ])
                            : scope.row.status == 2
                            ? _c("div", { staticClass: "table-txt" }, [
                                _c("i", { staticClass: "bg-danger" }),
                                _vm._v("\n          停用\n        "),
                              ])
                            : scope.row.status == 1
                            ? _c("div", { staticClass: "table-txt" }, [
                                _c("i", { staticClass: "bg-default" }),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t("setting.info.normal")) +
                                    "\n        "
                                ),
                              ])
                            : _c("div"),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4181761138
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.notEmployees == "未入职"
            ? _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: "操作",
                  "min-width": "180",
                  prop: "address",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._t("options", null, { data: scope.row })]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.notEmployees !== "未入职"
            ? _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: "操作",
                  "min-width": "180",
                  prop: "address",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._t("options", null, { data: scope.row })]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-fixed" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.where.page,
              "page-size": _vm.where.limit,
              "page-sizes": [15, 20, 30],
              total: _vm.total,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }